import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

const useIframeCommunication = props => {
    const handleReceiveMessage = event => {
        const { onReceiveMessage } = props

        onReceiveMessage && onReceiveMessage(event)
    }

    useEffect(() => {
        window.addEventListener('message', handleReceiveMessage)

        return () => window.removeEventListener('message', handleReceiveMessage, false)
    }, [])

    const serializePostMessageData = data => {
        if (typeof data === 'object') {
            return JSON.stringify(data)
        } else if (typeof data === 'string') {
            return data
        } else {
            return `${data}`
        }
    }

    const sendMessage = (postMessageData, iFrame) => {
        const { targetOrigin } = props
        const serializedData = serializePostMessageData(postMessageData)

        if (iFrame) iFrame.contentWindow.postMessage(serializedData, targetOrigin)
        else window.postMessage(serializedData, targetOrigin)
    }

    return [sendMessage]
}

const IframeCommunication = ({ children, ...props }) => {
    const [sendMessage] = useIframeCommunication(props)

    return typeof children == 'function' ? children({ sendMessage }) : children
}

IframeCommunication.defaultProps = {
    targetOrigin: '*',
}

IframeCommunication.propTypes = {
    onReceiveMessage: PropTypes.func,
    targetOrigin: PropTypes.string,
}

export default IframeCommunication
